<template>
    <reconciliation-step-template
        :nextStep="nextStep"
        :previousStep="previousStep"
        :loading="loading"
        @previous="$emit('previous')"
    >
        <template #header>
            <h2 class="mb-0">{{ $l10n.__('Visualisation de votre fichier CSV') }}</h2>
            <p class="fs-3 gray-80 mt-2 mb-0">
                {{
                    $l10n.__(
                        'Vérifiez les données ci-dessous, elles serviront à créer votre relevé bancaire compatible avec Sellsy.',
                    )
                }}
            </p>
            <p class="fs-3 gray-80 mt-0">
                {{
                    $l10n.__(
                        'Si le fichier contient des erreurs, il vous faudra modifier vos paramètres.',
                    )
                }}
            </p>
        </template>
        <template #content>
            <div v-loading="loading" class="step-container-table border-black">
                <TableSelectableColumns :lines="csv" :selectable="false" format="object" />
            </div>
        </template>
        <template #footer>
            <div class="aright">
                <CompassButton
                    v-if="previousStep"
                    :label="
                        $t.__(
                            'bankreconciliation.importsteps.ReconciliationStep6.modify_parameters',
                        )
                    "
                    type="secondary"
                    :disabled="loading"
                    @click="$emit('next', 'bankreconciliation-step2')"
                />
                <CompassButton
                    :label="
                        $t.__(
                            'bankreconciliation.importsteps.ReconciliationStep6.save_and_continue',
                        )
                    "
                    type="primary"
                    :disabled="!importAllowed || loading"
                    @click="goToNextStep"
                />
            </div>
        </template>
    </reconciliation-step-template>
</template>

<script>
import TableSelectableColumns from 'vcomponents/utilities/TableSelectableColumns.vue';
import ImportStepsMixins from './ImportStepsMixins';
import BankReconciliationImport from 'api/bankreconciliationImport';

export default {
    components: {
        TableSelectableColumns,
    },
    mixins: [ImportStepsMixins],
    data() {
        return {
            loading: true,
            importAllowed: false,
            headerPrevisualisation: {
                date: this.$l10n.__('Date'),
                label: this.$l10n.__('Label'),
                amount: this.$l10n.__('Montant'),
                type: this.$l10n.__('Type'),
                original_line: this.$l10n.__('Ligne originale'),
            },
        };
    },
    created() {
        BankReconciliationImport.getPreview(this.idImport).then((response) => {
            const csvTemp = response.csv;
            csvTemp.unshift(this.headerPrevisualisation);
            this.$emit('update-csv', csvTemp);
            this.$emit('update-import-id', this.idImport);
            this.importAllowed = response.import_allowed;
            this.loading = false;
        });
    },
    methods: {
        goToNextStep() {
            this.loading = true;
            BankReconciliationImport.process(this.idImport).then((response) => {
                this.$emit('update-csv', response.csv);
                this.$emit('next');
                this.loading = false;
            });
        },
    },
};
</script>


